module.exports = function() {
  return new Worker(__webpack_public_path__ + "8dfe4ce516ddb3349e40.worker.js");
};